import { IPaths } from "../types/types";

export const paths: IPaths = {
  stockOwners: '/stock-owners',
  stockOwnerDetails: '/stock-owners/details',
  warehouses: '/warehouses',
  palletes: '/palletes',
  attributes: '/attributes',
  dashboard: '/dashboard',
  orders: '/orders',
  promotions: '/promotions',

  stockInventory: '/stock-inventory',
  search: '/search',
  goals: '/goals',
  productItems: '/product-items',
  productItemsAdd: '/product-items/add',
  customerServcice: '/customer-service',
  orderDone: '/order/done',
  orderAddAsOwner: '/order/add',
  orderAddAsStockOwner: '/order/add',
  orderChooseStockOwner: '/order/stock-owner',
  orderChooseClient: '/order/client',
  orderChooseProducts: '/order/products',
  orderRecent: '/order/recent',
  ordersActive: '/orders/active',
  ordersHistory: '/orders/history',
  ordersCanceled: '/orders/canceled',
  orderDetails: '/orders/details',
  orderUpdate: '/orders/update',
  orderItem: '/order',
  ordersShoppingList: '/orders/shopping-list',
  ordersNewOrders: '/orders/new-orders',
  ordersCart: '/orders/cart',
  ordersNew: '/orders/view',
  orderNew: '/orders/new',
  ordersNewNeedToPay: '/orders/need-to-pay',
  ordersInProgress: '/orders/in-progress',
  ordersAddNewPrivious: '/orders/add-new-privious',
  ordersSentView: '/orders/sent-view',
  ordersCenceledView: '/orders/cenceled-view',
  ordersNewView: '/orders/view',
  integrationMantis: '/integration/mantis',
  client: '/client',
  favorites: '/favorites',
  trackTrace: '/track-trace',
  trackDrivers: '/track-trace/drivers',
  trackTrucks: '/track-trace/trucks',
  trackRoutes: '/track-trace/routes',
  trackRoutePlaning: '/track-trace/route-planing',
  trackPOD: '/track-trace/pod',
  trackRTT: '/track-trace/rtt',
  customer: '/customer',
  customerAdd: '/customer/add',
  suppliers: '/suppliers',
  suppliersAdd: '/suppliers/add',
  salesMarketing: '/marketing',
  salesMarketingOrders: '/marketing/order',
  salesMarketingCustomers: '/marketing/customer',
  salesMarketingAgents: '/marketing/agents',
  salesMarketingPromotions: '/marketing/promotions',
  salesMarketingGoals: '/marketing/goals',
  salesMarketingGoalsPerPeriod: '/marketing/goals/per-period',
  salesMarketingGoalsAgents: '/marketing/goals/agents',
  salesMarketingGoalsClients: '/marketing/goals/clients',
  salesMarketingCustomerService: '/marketing/customer-service',
  salesMarketingDeals: '/marketing/deals',
  salesMarketingGoalsAgentItem: '/marketing/goals/agent/:id',
  salesMarketingGoalsClientItem: '/marketing/goals/client/:id',
  items: '/items',
  inventory: '/inventory',
  inventoryInventory: '/inventory/main',
  inventoryWidget: '/inventory/widget',
  inventoryLog: '/inventory/log',
  inventoryExpectedReceipts: '/inventory/expected-receipts',
  inventoryReceipts: '/receipts',
  inventoryReceiptsActive: '/receipts/active',
  inventoryReceiptsHistory: '/receipts/history',
  inventoryReceiptsCanceled: '/receipts/canceled',
  inventoryReceiptAdd: '/receipts/add',
  inventoryReceiptDetails: '/receipts/details',
  inventoryReceiptUpdate: '/receipts/update',
  inClient: '/client/in-client',
  inClientReport: '/client/in-client/report',
  inClientInReport: '/client/in-client/in-report',
  inClientHome: '/client/in-client/home',
  inClientReceipt: '/client/in-client/receipt',
  inClientFlag: '/client/in-client/flag',
  inClientPriceList: '/client/in-client/price-list',
  inClientUser: '/client/in-client/user',
  inClientArchive: '/client/in-client/archive',
  inClientSettings: '/client/in-client/settings',
  inClientPaymentStatistics: '/client/in-client/payment-statistics',

  reports: '/reports',
  reportClient: '/reports/client',
  reportAgent: '/reports/agent',
  reportSale: '/reports/sale',
  reportNewSale: '/reports/new-sale',
  reportSaleItem: '/reports/detail/:id',
  reportClientDetail: '/reports/client/:id',
  tasks: '/tasks',
  tasksMore: '/tasks/more',
  reportsClientActivity: '/reports/client-activity',
  reportsClientPricing: '/reports/client-pricing',
  reportsAgentGoals: '/reports/agent-goals',
  feedbacks: '/feedbacks',
  questionnaires: '/questions',
  deals: '/deals',
  addDeal: '/deals/add-deal',
  notifications: '/notifications',
  customers: '/customers',
  customersInClient: '/customers/client/in-client',
  customersInClientFlag: '/customers/client/in-client/flag',
  customersInClientUser: '/customers/client/in-client/user',
  customersInClientSettings: '/customers/client/in-client/settings',
  agents: '/agents',
  categories: '/categories',
  returns: '/returns',
  returnsView: '/returns/view',
  prioritizeShipments: '/prioritize-shipments',
  prioritizeShipmentsDeliveryPriority:
    '/prioritize-shipments/delivery-priority',
  driverTasks: '/driver-tasks',
  information: '/information/driver',
  informationCargoTruck: '/information/cargo-truck',
  informationRoute: '/information/route',
  concentrationReports: '/concentration-reports',
  concentrationReportsView: '/concentration-reports/view',
  divisionLines: '/division-lines',
  inFeedback: '/feedbacks/in-feedback',
  newQuestion: '/questions/new-question',
  questionReport: '/questions/question-report',
  inAgentView: '/agents/in-agent-view',
  newAgent: '/agents/new-agent',
  inDriverTask: '/tasks/in-driver-task',
  inDriverTaskDone: '/orders/in-driver-task-done',
  products: '/products',
  reportsDailySales: '/reports/daily-sales',
  reportsClientSales: '/reports/client-sales',
  reportsGiuls: '/reports/giuls',
  settings: '/settings',
  settingsAdminManagement: '/settings/admin-management',
  settingsStockOwnersManagement: '/settings/stockowners-management',
  settingsUserSettings: '/settings/user-settings',
  settingsCompanySettings: '/settings/company-settings',
  settingsIntegrations: '/settings/integrations',
  settingsAttributes: '/settings/attributes',
};
